// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const VscodeIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <g clipPath="url(#vscode_svga)">
      <mask
        id="vscode_svgb"
        width={22}
        height={22}
        x={1}
        y={1}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M16.6 22.85q.54.2 1.1-.04l4.52-2.18c.48-.23.78-.71.78-1.24V4.6c0-.53-.3-1-.78-1.24L17.7 1.2a1.4 1.4 0 0 0-1.56.27l-8.67 7.9L3.68 6.5a.9.9 0 0 0-1.17.05L1.3 7.65c-.4.37-.4 1 0 1.36L4.57 12 1.3 14.99c-.4.36-.4 1 0 1.35l1.21 1.1c.33.3.82.32 1.17.06l3.78-2.87 8.67 7.91q.21.2.47.31m.9-15.84L10.92 12l6.58 5z"
          clipRule="evenodd"
        />
      </mask>
      <g mask="url(#vscode_svgb)">
        <path
          fill="#0065A9"
          d="M22.22 3.38 17.7 1.19a1.4 1.4 0 0 0-1.57.27L1.3 14.99c-.4.36-.4 1 0 1.35l1.2 1.1c.34.3.83.32 1.18.06L21.54 3.94a.91.91 0 0 1 1.46.73V4.6c0-.52-.3-1-.78-1.23"
        />
        <g filter="url(#vscode_svgc)">
          <path
            fill="#007ACC"
            d="m22.22 20.62-4.53 2.19c-.53.25-1.15.14-1.57-.27L1.3 9.01c-.4-.36-.4-1 0-1.35l1.2-1.1a.9.9 0 0 1 1.18-.06l17.87 13.56a.91.91 0 0 0 1.46-.73v.06c0 .52-.3 1-.78 1.23"
          />
        </g>
        <g filter="url(#vscode_svgd)">
          <path
            fill="#1F9CF0"
            d="M17.69 22.8c-.53.26-1.15.15-1.57-.26a.8.8 0 0 0 1.38-.57V2.03a.8.8 0 0 0-1.37-.57 1.4 1.4 0 0 1 1.56-.27l4.53 2.18c.48.23.78.71.78 1.24V19.4c0 .53-.3 1-.78 1.24z"
          />
        </g>
        <path
          fill="url(#vscode_svge)"
          fillRule="evenodd"
          d="M16.59 22.85c.34.13.74.13 1.09-.04l4.53-2.18c.47-.23.78-.71.78-1.24V4.6c0-.53-.3-1-.78-1.24L17.68 1.2a1.4 1.4 0 0 0-1.56.27l-8.68 7.9L3.67 6.5a.9.9 0 0 0-1.17.05l-1.21 1.1c-.4.37-.4 1 0 1.36L4.56 12 1.3 14.99c-.4.36-.4 1 0 1.35l1.2 1.1c.33.3.83.32 1.18.06l3.77-2.87 8.68 7.91q.2.2.47.31m.9-15.84L10.91 12l6.58 5z"
          clipRule="evenodd"
          opacity={0.25}
          style={{
            mixBlendMode: "overlay",
          }}
        />
      </g>
    </g>
    <defs>
      <filter
        id="vscode_svgc"
        width={38.68}
        height={33.29}
        x={-7.35}
        y={-2.02}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={4.17} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          mode="overlay"
          result="effect1_dropShadow_4534_3985"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4534_3985"
          result="shape"
        />
      </filter>
      <filter
        id="vscode_svgd"
        width={23.54}
        height={38.55}
        x={7.79}
        y={-7.28}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={4.17} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          mode="overlay"
          result="effect1_dropShadow_4534_3985"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4534_3985"
          result="shape"
        />
      </filter>
      <linearGradient
        id="vscode_svge"
        x1={11.99}
        x2={11.99}
        y1={1.06}
        y2={22.94}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <clipPath id="vscode_svga">
        <path fill="#fff" d="M1 1h22v22H1z" />
      </clipPath>
    </defs>
  </svg>,
  "Vscode",
);
export default VscodeIcon;
